export const microsoftconfig = {
appId: '26939f32-1806-4e09-9fb0-66f80f3b34c9',
redirectUri: 'https://app.successguardian.in',
scopes: [ "user.read" ],
}

export const outlookconfig = {
    appId: '93a05550-24c1-4954-a529-926843c30c97',
    redirectUri: 'auth/microsoftmail/callback',
    scopes: [ "Mail.ReadWrite Mail.Send offline_access"],
    }
    

export const googleconfig = {
    CLIENT_ID: '737739086442-e5kn1mr67tefjm0n1o5k4jg0gf9rimoo.apps.googleusercontent.com',
    redirectUri: 'auth/google/callback',
    scopes: [ "https://www.googleapis.com/auth/calendar" ],
    }

export const gmailconfig = {
        CLIENT_ID: '134279620566-qs1jqd87jlihpfdlrteq9nemfc0nra74.apps.googleusercontent.com',
        redirectUri: 'auth/googlegmail/callback',
        scopes: [ "https://www.googleapis.com/auth/gmail.modify" ],
        }


export const quickbooksconfig = {
        CLIENT_ID: 'AB5VKkgcmLzDV0f6Q554U1skUOGLXxKlOqvTEQwtmBf1LMxjb8',
        REDIRECT_URI: 'auth/quickbooks/callback',
        scope: [ "com.intuit.quickbooks.accounting"],
        }

// 